import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Card,
  Button,
  Stack,
  Paper,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DaalchiniLogo from "../../assets/dalchini_logo.png";

export default function ClaimSuccess({data}) {
  return (
    <Box
      sx={{
        maxWidth: 420,
        mx: "auto",
        minHeight: "100vh",
        bgcolor: "#F4F6F8",
        p: 2,
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" mb={2}>
        <IconButton size="small">
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>

        <Box sx={{ flex: 1, textAlign: "center" }}>
          <img src={DaalchiniLogo} style={{ width: 80 }} />
        </Box>
      </Stack>

      {/* Success Icon */}
      <Box textAlign="center" mt={2} mb={2}>
        <Box
          sx={{
            width: 110,
            height: 110,
            borderRadius: "50%",
            border: "3px solid #12B76A",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            position: "relative",
            bgcolor: "#fff",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: 22,
              color: "#E50914",
              letterSpacing: 1,
            }}
          >
            NETFLIX
          </Typography>

          {/* Green Check Badge */}
          <CheckCircleIcon
            sx={{
              position: "absolute",
              bottom: 0,
              right: 5,
              fontSize: 28,
              color: "#12B76A",
              bgcolor: "#fff",
              borderRadius: "50%",
            }}
          />
        </Box>

        <Typography fontWeight={700} fontSize={20} mt={2}>
          Successfully Claimed!
        </Typography>

        <Typography fontSize={14} color="text.secondary">
          Enjoy Your Subscription
        </Typography>
      </Box>

      {/* Plan Details Card */}
      <Card sx={{ borderRadius: 3, p: 2.5, mb: 3 }}>
        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Typography fontSize={13} color="text.secondary">
            Plan Details
          </Typography>
          <Typography fontSize={13} color="#12B76A" fontWeight={600}>
            Active
          </Typography>
        </Stack>

        <Typography fontWeight={600}>
          Netflix Premium (6 Months)
        </Typography>

        <Typography fontSize={13} color="text.secondary" mb={2}>
          4k Ultra HD, 4 Screen, No Ads.
        </Typography>

        <Stack spacing={1}>
          <Typography fontSize={13}>
            <strong>Purchased With:</strong><br />
            amisha01@gmail.com
          </Typography>

          <Typography fontSize={13}>
            <strong>Valid Until</strong><br />
            Jan 24, 2026
          </Typography>
        </Stack>
      </Card>

      {/* Reward Box */}
      <Paper
        sx={{
          borderRadius: 3,
          p: 2,
          mb: 3,
          bgcolor: "#EAF7F1",
        }}
      >
        <Typography fontWeight={600} mb={0.5}>
          Reward Unlocked!
        </Typography>

        <Typography fontSize={13} color="text.secondary" mb={1}>
          You've Won Cashback On This Order
        </Typography>

        <Button
          variant="contained"
          size="small"
          sx={{
            bgcolor: "#12B76A",
            textTransform: "none",
            borderRadius: 2,
            "&:hover": { bgcolor: "#0EA861" },
          }}
        >
          Claim Now →
        </Button>
      </Paper>

      {/* Go To Netflix Button */}
      <Button
        fullWidth
        variant="contained"
        sx={{
          bgcolor: "#12B76A",
          borderRadius: 3,
          py: 1.6,
          fontWeight: 700,
          textTransform: "none",
          mb: 2,
          "&:hover": { bgcolor: "#0EA861" },
        }}
      >
        Go To Netflix
      </Button>

      {/* Home Button */}
      <Button
        fullWidth
        variant="outlined"
        sx={{
          borderRadius: 3,
          py: 1.6,
          fontWeight: 600,
          textTransform: "none",
          color:"#404237",
          borderColor:"#000000"
        }}
      >
        Home
      </Button>
    </Box>
  );
}